import { Column } from "./Column"
import { Row } from "./Row"
import { TextComponent } from "./TextComponent"

export const DropDown = ({ className, condition, options }:
    {
        className: string,
        condition: boolean,
        options: { text: string, icon?: JSX.Element, onClick?: () => void }[],
    }
) => {
    return (
        <div className={`${className} ${!condition && "hidden"} z-[2] bg-white rounded-lg shadow w-fit select-none `}>
            <Column className="py-2 text-graySecondary font-semibold">
                {options.map((option, index) => (
                    <button
                        key={index}
                        className="w-full px-4 py-2 transition-colors ease-in-out duration-300 hover:bg-grayLight"
                        aria-label={option.text}
                        onClick={option.onClick}
                    >
                        <Row crossAxisAlignment="center" className="gap-2">
                            {option.icon}
                            <TextComponent variant="nh6">
                                {option.text}
                            </TextComponent>
                        </Row>
                    </button>
                ))}
            </Column>
        </div>
    )
}